import React from "react";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import AdminEditPrsContent from "./components/adminEditPrsContent.js";

function AdminEditPrs() {
  return (
    <div>
      <TitleHolder>Edit Purchase Requisitions </TitleHolder>
      <StepperContentHolder>
        <AdminEditPrsContent />
      </StepperContentHolder>
    </div>
  );
}

export default AdminEditPrs;
